import React from 'react';
import PropTypes from 'prop-types';
import StepList from './trial/StepList';
import translate from '../commonComponents/translate';
import CheckedIcon from './trial/icons/CheckedIcon';

function Card({ t, isAdmin, onClick, active, primaryColor }) {
  const title = isAdmin ? t('portal.admin') : t('portal.user');
  const content = isAdmin ? t('portal.admin.content') : t('portal.user.content');
  const image = isAdmin ? '/images/trial/adminPortal.png' : '/images/trial/userPortal.png';
  const style = isAdmin ? { width: '205px', height: '170px' } : { width: '275px', height: '170px' };
  return (
    <button
      type="button"
      onClick={() => onClick(isAdmin ? 'admin' : 'user')}
      className={`trial-portal-card ${active ? 'trial-portal-card-active' : ''}`}
    >
      <div className="trial-card-checked">
        <p className="trial-portal-card-title">{title}</p>
        {active && (<CheckedIcon width="20px" height="20px" color={primaryColor} />)}
      </div>
      <p className="trial-portal-card-content">{content}</p>
        <img style={style} src={image} alt={title} />
    </button>
  );
}

Card.propTypes = {
  t: PropTypes.func.isRequired,
  active: PropTypes.string.isRequired,
  isAdmin: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  primaryColor: PropTypes.string.isRequired,
};
Card.defaultProps = {
  isAdmin: false,
};

function Step3({ t, step, onSubmit, onGoBack, isLoading, onClickCard, activeCard, alreadyInvited, primaryColor }) {
  return (
    <>
      <StepList activeStep={step} ignore />
      <h2 className="trial-header trial-header-step3">{t('trial.step3.title')}</h2>
      <h4 className="trial-subheader trial-subheader-step3">{t('trial.step3.content')}</h4>

      <div className="trial-portals">
        <Card
          t={t}
          isAdmin
          active={activeCard === 'admin'}
          onClick={() => {}}
          primaryColor={primaryColor}
        />
        <Card t={t} active={activeCard === 'user'} onClick={onClickCard} primaryColor={primaryColor} />
      </div>
      <div className="button-container">
        {!alreadyInvited && (
          <button type="button" onClick={onGoBack} className="button-trial-back">
            <span className="button-text">{t('trial.previous')}</span>
          </button>
        )}
        <button type="submit" onClick={onSubmit} className="button-trial" disabled={isLoading}>
          <span className="button-text">{t('next')}</span>
          {isLoading && <i className="fa fa-spinner spinner" />}
        </button>
      </div>
      <div>
        <p className="trial-hint">{t('trial.step3.hint')}</p>
      </div>
    </>
  );
}

Step3.propTypes = {
  t: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onGoBack: PropTypes.func.isRequired,
  onClickCard: PropTypes.func.isRequired,
  step: PropTypes.number.isRequired,
  isLoading: PropTypes.bool.isRequired,
  activeCard: PropTypes.string.isRequired,
  alreadyInvited: PropTypes.bool.isRequired,
  primaryColor: PropTypes.string.isRequired,
};

export default translate(Step3);
